module.exports = __webpack_public_path__ + "img/luoliman.eee8ef13.png";